import Tracking from '../analytics/Tracking';

$(function () {
    function addEventOnBtn(btnName, eventCategoryEdition, url) {
        var btnOverlay = document.getElementById(`hpwOverlay-${btnName}Btn`);
        var btnInBody = document.getElementById(`hpwInBody-${btnName}Btn`);

        [btnOverlay, btnInBody].forEach(b => {
            b && b.addEventListener("click", function(event) {
                if(url) {
                    event.preventDefault();
                }

                Tracking.track(`action.${event.target.id}`, window.hardPaywallTrackingData);

                var boxType = b.id.indexOf("Overlay") !== -1 ? "Overlay" : "Box";
                window.dataLayer = window.dataLayer || [];
                window.dataLayer.push({
                    'event': 'UniversalEvent',
                    'eventCategory': `${eventCategoryEdition} | ${boxType}`,
                    'eventAction': 'Click',
                    'eventLabel': btnName
                });

                if(url) {
                    window.location.href =  $(b).attr("href") || url;
                }
            })
        })

    }

    if(window.hardPaywallTrackingData) {
        var contentEditionId = window.hardPaywallTrackingData.editionId;
        var eventCategoryEdition = "Wort+";

        if(contentEditionId === "en") {
            eventCategoryEdition = "LT+";

            addEventOnBtn("month", eventCategoryEdition, "/monthly");
            addEventOnBtn("quarterly", eventCategoryEdition, "/quarterly");
            addEventOnBtn("year", eventCategoryEdition, "/yearly");
        } else if(contentEditionId === "de") {
            addEventOnBtn("offers", eventCategoryEdition, "/de/special-offer");
        }
        addEventOnBtn("login", eventCategoryEdition)
    }
})



// WEBPACK FOOTER //
// ./js/paid-content/PaidContent.js